export default {"src":"/_next/static/media/blue_flower.4726337a.svg","height":409,"width":241,"blurWidth":0,"blurHeight":0};